<template>
 
    <div class="wrapper-page">
      <header class="header">
        <div class="header-content">
          <div class="profile-picture-block">
            <div class="my-photo">
              <img :src="`${news.data.image}`" class="img-fluid" alt="image" />
            </div>
          </div>
          <!-- Header Head -->
          <div class="site-title-block">
            <div class="site-title">{{ news.data.name }}</div>
            {{ news.data.email }}
            <div class="type-wrap"></div>
          </div>
          <ul class="utpl_biografia">
            <li class="titulo_li">
              Facultad
              <ul>
                <li>{{ news.data.facultad }}</li>
              </ul>
            </li>
            <li class="titulo_li">
              Departamento
              <ul>
                <li>{{ news.data.departamento }}</li>
              </ul>
            </li>
            <li class="titulo_li">
              Cargo
              <ul>
                <li>{{ news.data.facultad }}</li>
              </ul>
            </li>
            <li class="titulo_li">
              Grupo de investigacion
              <ul>
                <li>{{ news.data.facultad }}</li>
              </ul>
            </li>
          </ul>
          <!-- /Header Head -->

          <!-- /Navigation -->
        </div>
      </header>
      <!-- /Header -->

      <!-- About Me Subpage -->
      <section id="about-me" class="sub-page">
       <div class="content-pages">
        <div class="sub-page-inner">
        <div class="section-title">
                                <div class="main-title">
                                    <div class="title-main-page">
                                        <h4>Docente investigador </h4>
                                    </div>
                                </div>
                            </div>
         
          <div class="section-content">
            <!-- about me -->
            <div class="row pb-30">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              
               
                
                <p class="about-content">
                  {{ news.data.bio }}
                </p>

                <ul class="bout-list-summry row">
                  <li class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <div class="icon-info">
                      <i class="lnr lnr-briefcase"></i>
                    </div>
                    <div class="details-info">
                      <h6>Indicador 1</h6>
                      <p>xxxxxxx</p>
                    </div>
                  </li>
                  <li class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <div class="icon-info">
                      <i class="lnr lnr-layers"></i>
                    </div>
                    <div class="details-info">
                      <h6>Indicador 1</h6>
                      <p>xxxxxx</p>
                    </div>
                  </li>
                  <li class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <div class="icon-info">
                      <i class="lnr lnr-coffee-cup"></i>
                    </div>
                    <div class="details-info">
                      <h6>Indicador</h6>
                      <p>xxxxxx</p>
                    </div>
                  </li>
                </ul>
              </div>

              <div class="col-xs-6 col-sm-12 col-md-6 col-lg-6">
                <div class="box-img">
                  <img
                    :src="`${news.data.image}`"
                    class="img-fluid"
                    alt="image"
                  />
                </div>
              </div>
            </div>
            <!-- /about me -->
          </div>
        </div>
        </div>
      </section>
      <!-- About Me Subpage -->


  
  </div>
</template>

<script>
import axios from "axios";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
let jsonpAdapter = require("axios-jsonp");

const config = {
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
  responseType: "application/javascript",
  adapter: jsonpAdapter,
  //callbackParamName: 'c' ,
};

export default {
  name: "utpl-investigacion-docente",

  data() {
    return { news: [], cargos: [], grupos: [], revistas: [], indicadores:[] };
  },
  props: {
    usuario: {
      type: String,
      default: "",
    },
  },
  methods: {
    getNews() {
      console.log(config);
      axios
        .get(
          "https://sica.utpl.edu.ec/api/persons/" +
            this.usuario +
            "?token=GDWgY4xyaKQ5hxFe",
          config
        )
        .then((response) => JSON.stringify((this.news = response)));
      console.log(this.news);
    },
    getcargos() {
      console.log(config);
      axios
        .get(
          "https://sica.utpl.edu.ec/api/persons/charges/?token=GDWgY4xyaKQ5hxFe&person=" +
            this.usuario,
          config
        )
        .then((response) => JSON.stringify((this.cargos = response.data)));
      console.log(this.cargos);
    },
    getgrupos() {
      console.log(config);
      axios
        .get(
          "https://sica.utpl.edu.ec/api/groups/?token=GDWgY4xyaKQ5hxFe&filters&person=" +
            this.usuario,
          config
        )
        .then((response) => JSON.stringify((this.grupos = response.data)));
      console.log(this.grupos);
    },
    getrevistas() {
      console.log(config);
      axios
        .get(
          "https://sica.utpl.edu.ec/api/authnames/?token=GDWgY4xyaKQ5hxFe&filters&person=" +
            this.usuario,
          config
        )
        .then((response) => JSON.stringify((this.revistas = response.data)));
      console.log(this.revistas);
    },

    getindicadores() {
      console.log(config);
      axios
        .get(
          "https://sica.utpl.edu.ec/api/persons/indicators/?token=GDWgY4xyaKQ5hxFe&person=" +
            this.usuario,
          config
        )
        .then((response) => JSON.stringify((this.indicadores = response.data)));
      console.log(this.indicadores);
    },
  },
  mounted() {
    this.getNews();
    this.getcargos();
    this.getgrupos();
    this.getrevistas();
  },
};
</script>
<style>
@import "../styles/style-investigacion.css";
</style>
